import { useParams, useSearchParams } from 'react-router-dom';
import { useStateValue } from '../../index';
import { setBookingData } from '../actions';
import useRoomRate from '../../room-rate/hooks/useProducer';

const useBookingData = () => {
  const [{ booking }, dispatch] = useStateValue();
  const { setRoomRate } = useRoomRate();
  const { hotelId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const initialData = () => {
    const obj = { hotel_id: hotelId, ...Object.fromEntries([...searchParams]) };
    dispatch(setBookingData(obj));
    if (searchParams.has('rooms') && searchParams.has('check_in') && searchParams.has('check_out') && searchParams.has('adults')) {
      setRoomRate(obj);
    }
  };
  const change = (data) => {
    const { hotel_id, city_id, ...searchParameters } = data;
    const obj = { ...Object.fromEntries([...searchParams]), ...searchParameters };
    setSearchParams(obj);
    dispatch(setBookingData(obj));
    setRoomRate(obj);
  };

  return { booking, change, initialData };
};

export default useBookingData;
